import m from "mithril"
import Kindle from "../shared/kindle.js"
import TaskRootContainer from "./tasks-view.js"
import "../shared/base.css"
import "../shared/standalone.css"
import "../shared/util.js"

// Kindle.isKindle = true;
// Kindle.debug = true;
Kindle.init(false);


document.redraw = function(flashNow) {
  m.redraw();
  Kindle.refreshScreen(flashNow);
}

document.title = "Tasks"
document.addEventListener("DOMContentLoaded", function() {
  TaskRootContainer.standalone = true;
  m.mount(document.getElementById("root"), TaskRootContainer)
});
